module.exports = [{
      plugin: require('../../../node_modules/gatsby-plugin-nprogress/gatsby-browser.js'),
      options: {"plugins":[],"color":"#ffaa00","showSpinner":false},
    },{
      plugin: require('../../../node_modules/@carrotsearch/gatsby-transformer-html/gatsby-browser.js'),
      options: {"plugins":[],"variables":{"NPM_VERSION":"1.0.0"}},
    },{
      plugin: require('../../../node_modules/gatsby-plugin-offline/gatsby-browser.js'),
      options: {"plugins":[]},
    },{
      plugin: require('../../../node_modules/gatsby-plugin-catch-links/gatsby-browser.js'),
      options: {"plugins":[]},
    },{
      plugin: require('../../../node_modules/@carrotsearch/gatsby-theme-apidocs/gatsby-browser.js'),
      options: {"plugins":[],"navigation":"/home/runner/actions-runner/_work/dotatlas/dotatlas/modules/doc/src/navigation.json","logo":"/home/runner/actions-runner/_work/dotatlas/dotatlas/modules/doc/src/logo.html","footer":"/home/runner/actions-runner/_work/dotatlas/dotatlas/modules/doc/src/footer.html","basePath":"content","variables":{"NPM_VERSION":"1.0.0"}},
    },{
      plugin: require('../gatsby-browser.js'),
      options: {"plugins":[]},
    },{
      plugin: require('../../../node_modules/gatsby/dist/internal-plugins/partytown/gatsby-browser.js'),
      options: {"plugins":[]},
    }]
